import BigNumber from 'bignumber.js'
import Vue from 'vue'
import Constant from '@/configs/constant'
import WAValidator from '@swyftx/api-crypto-address-validator/dist/wallet-address-validator.min.js'
import bchaddr from 'bchaddrjs'

export default new Vue({
  methods: {
    convertTsToDate (ts) {
      return this.$moment(Number(ts)).format('YYYY-MM-DD')
    },
    multipliedBy (amount, by) {
      return new BigNumber(amount).multipliedBy(by).toFixed()
    },
    dividedBy (amount, by) {
      return new BigNumber(amount).dividedBy(by).toFixed()
    },
    isInteger (num) {
      return new BigNumber(num).isInteger()
    },
    sleep (mils) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, mils)
      })
    },
    removeTokenPrefix (hex) {
      return hex.substring(0, 2) === '0x' ? hex.substring(2) : hex
    },
    addAddressPrefix (str) {
      const size = str.length
      return this.genratePrefixStr(64 - size) + str
    },
    genratePrefixStr (num) {
      const str = '00000000000000000000000000000000000000000000000000000000000000000000000000000000000'
      return str.substring(0, num)
    },
    convertStringToHex (value) {
      return new BigNumber(`${value}`).toString(16)
    },
    sanitizeHex (hex) {
      hex = hex.substring(0, 2) === '0x' ? hex.substring(2) : hex
      if (hex === '') {
        return ''
      }
      hex = hex.length % 2 !== 0 ? '0' + hex : hex
      return '0x' + hex
    },
    convertAmountToRawNumber (value, decimals = 18) {
      return new BigNumber(`${value}`).times(new BigNumber('10').pow(decimals)).toString()
    },
    convertRawNumberToAmount (val, decimal = 18) {
      return new BigNumber(`${val}`).dividedBy(new BigNumber('10').pow(decimal)).toString()
    },
    // Transform functions
    transformUserPPS (data) {
      if (data.ALEO) {
        const totalPps = this.dividedBy(data.ALEO, 5)
        data.totalPps = this.numberWithCommas(totalPps)
        data.beautyTotalBuy = this.numberWithCommas(data.ALEO)
      }
      if (data.KAS) {
        data.kasAmount = this.numberWithCommas(data.KAS)
      }
      return data
    },
    transformUserMaxout (data) {
      data.beautyTotalCom = this.numberWithCommas(data.totalCom)
      data.beautyMaxout = this.numberWithCommas(data.maxout)
      data.beautyTotalInvest = this.numberWithCommas(data.totalInvest)
      const percent = new BigNumber(data.totalCom).dividedBy(data.maxout).multipliedBy(100)
      data.percent = this.numberWithCommas(percent)
      data.percentView = new BigNumber(percent).dp(0, BigNumber.ROUND_DOWN).toNumber()
      return data
    },
    transformUserOverview (data) {
      data.beautyTotalSale = this.numberWithCommas(data.totalSale)
      data.beautyTotalComRefU = this.numberWithCommas(data.totalComRefU)
      data.beautyTotalComRefA = this.numberWithCommas(data.totalComRefA)
      data.beautyTotalComRefK = this.numberWithCommas(data.totalComRefK)
      data.beautyTotalComBrandU = this.numberWithCommas(data.totalComBrandU)
      data.beautyTotalComBrandA = this.numberWithCommas(data.totalComBrandA)
      data.beautyTotalComBrandK = this.numberWithCommas(data.totalComBrandK)
      data.beautyTotalBonus = this.numberWithCommas(data.totalBonus)
      data.beautyTotalBuy = this.numberWithCommas(data.totalBuy)
      data.beautyTotalAleo = this.numberWithCommas(data.totalAleo)

      return data
    },
    transformComGlobalBonusHistory (data) {
      if (!data.data || !data.data.length) return data
      const dataTemp = data.data
      for (let i = 0; i < dataTemp.length; i++) {
        dataTemp[i].beautyAmount = this.numberWithCommas(dataTemp[i].amount)
        dataTemp[i].beautyCreatedAt = this.$moment(dataTemp[i].createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
      }
      return data
    },
    transformComLeaderBonusHistory (data) {
      if (!data.data || !data.data.length) return data
      const dataTemp = data.data
      for (let i = 0; i < dataTemp.length; i++) {
        dataTemp[i].beautyAmount = this.numberWithCommas(dataTemp[i].amount)
        dataTemp[i].beautyCreatedAt = this.$moment(dataTemp[i].createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
      }
      return data
    },
    transformComFundCareHistory (data) {
      if (!data.data || !data.data.length) return data
      const dataTemp = data.data
      for (let i = 0; i < dataTemp.length; i++) {
        dataTemp[i].beautyAmount = this.numberWithCommas(dataTemp[i].amount)
        dataTemp[i].beautyCreatedAt = this.$moment(dataTemp[i].createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
      }
      return data
    },
    transformIeoRounds (data) {
      if (!data || !data.length) return []
      for (let i = 0; i < data.length; i++) {
        let temp = data[i]
        temp = this.transformIeoRound(temp)
        temp.stt = i + 1
      }
      return data
    },
    transformIeoRound (data) {
      data.beautyStartTimeRound = this.$moment(data.startTimeRound * 1000).format('YYYY-MM-DD HH:mm:ss')
      data.beautyEndTimeRound = this.$moment(data.endTimeRound * 1000).format('YYYY-MM-DD HH:mm:ss')
      data.beautyTotalTokenSale = this.numberWithCommas(data.totalTokenSale)
      if (data.totalTokenSold !== null && data.totalTokenSold !== undefined) {
        data.totalRemaining = data.totalTokenSale - data.totalTokenSold
        data.beautyTotalRemaining = this.numberWithCommas(data.totalRemaining)
        data.percent = new BigNumber(data.totalRemaining).dividedBy(data.totalTokenSale).multipliedBy(100).dp(0, BigNumber.ROUND_DOWN).toNumber()
      } else {
        data.totalRemaining = data.totalTokenSale
        data.beautyTotalRemaining = this.numberWithCommas(data.totalRemaining)
        data.percent = 100
      }
      return data
    },
    transformIeoPackages (data) {
      for (let i = 0; i < data.length; i++) {
        data[i].beautyTokenAmountBuy = this.numberWithCommas(data[i].tokenAmountBuy)
        data[i].bonus && (data[i].bonus.beautyTokenBonus = this.numberWithCommas(data[i].bonus.tokenBonus))
      }
      return data
    },
    transformUserIeos (data) {
      for (let i = 0; i < data.length; i++) {
        data[i].beautyAmount = this.numberWithCommas(data[i].amount)
        data[i].beautyAmountBonus = this.numberWithCommas(data[i].amountBonus)
        data[i].beautyTotalRelease = this.numberWithCommas(data[i].totalRelease)
        data[i].beautyCreatedAt = this.$moment(data[i].createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
      }
      return data
    },
    transformUserReferralIeo (data) {
      if (!data.data || !data.data.length) return data
      const dataTemp = data.data
      for (let i = 0; i < dataTemp.length; i++) {
        dataTemp[i].beautyAmount = this.numberWithCommas(dataTemp[i].amount)
        dataTemp[i].beautyCreatedAt = this.$moment(dataTemp[i].createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
      }
      data.data = dataTemp
      return data
    },
    transformIeoBalances (data) {
      for (let i = 0; i < data.length; i++) {
        data[i].balanceUsdt = new BigNumber(data[i].balanceIeo).multipliedBy(data[i].rate).dp(data[i].decimal || 2, BigNumber.ROUND_DOWN).toNumber()
        data[i].beautyBalance = this.numberWithCommas(data[i].balanceIeo)
        data[i].beautyBalanceUsdt = this.numberWithCommas(data[i].balanceUsdt)
      }
      return data || []
    },
    transformMainBalances (data) {
      for (let i = 0; i < data.length; i++) {
        data[i].balanceUsdt = new BigNumber(data[i].balanceMain).multipliedBy(data[i].rate).dp(data[i].decimal || 2, BigNumber.ROUND_DOWN).toNumber()
        data[i].beautyBalance = this.numberWithCommas(data[i].balance)
        data[i].beautyBalanceUsdt = this.numberWithCommas(data[i].balanceUsdt)
      }
      return data || []
    },
    transformStakingBalances (data) {
      for (let i = 0; i < data.length; i++) {
        data[i].balanceUsdt = new BigNumber(data[i].balanceStaking).multipliedBy(data[i].rate).dp(data[i].decimal || 2, BigNumber.ROUND_DOWN).toNumber()
        data[i].beautyBalance = this.numberWithCommas(data[i].balanceStaking)
        data[i].beautyBalanceUsdt = this.numberWithCommas(data[i].balanceUsdt)
        data[i].beautyBalanceReStaking = this.numberWithCommas(data[i].balanceReStaking)
        data[i].balanceTotal = new BigNumber(data[i].balanceStaking).plus(data[i].balanceReStaking).toNumber()
        data[i].beautyBalanceTotal = this.numberWithCommas(data[i].balanceTotal)
      }
      return data || []
    },
    transformCommHistory (data) {
      if (!data || !data.length) return data
      const dataTemp = data
      for (let i = 0; i < dataTemp.length; i++) {
        dataTemp[i].beautyFromAmount = this.numberWithCommas(dataTemp[i].fromAmount)
        dataTemp[i].beautyAmount = this.numberWithCommas(dataTemp[i].amount)
        dataTemp[i].beautyAmountUsdt = this.numberWithCommas(dataTemp[i].amountUsdt)
        dataTemp[i].beautyAmountPackage = this.numberWithCommas(dataTemp[i].amountPackage)
        dataTemp[i].beautyCreatedAt = this.$moment(dataTemp[i].createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
        if (dataTemp[i].ratio && dataTemp[i].percent) {
          if (dataTemp[i].ratio === 1) {
            dataTemp[i].ratio = 0.8
          }
          dataTemp[i].percentHistory = (dataTemp[i].percent / dataTemp[i].ratio * 100).toFixed(2)
        }
      }
      data = dataTemp
      return data
    },
    transformCommAleoHistory (data) {
      if (!data || !data.length) return data
      const dataTemp = data
      for (let i = 0; i < dataTemp.length; i++) {
        dataTemp[i].beautyAmount = this.numberWithCommas(dataTemp[i].amount)
        dataTemp[i].beautyTotalBuy = this.numberWithCommas(dataTemp[i].totalBuy)
        dataTemp[i].beautyCreatedAt = this.$moment(dataTemp[i].cretedAt * 1000).format('YYYY-MM-DD HH:mm:ss')
        if (dataTemp[i].ratio && dataTemp[i].percent) {
          if (dataTemp[i].ratio === 1) {
            dataTemp[i].ratio = 0.8
          }
          dataTemp[i].percentHistory = (dataTemp[i].percent / dataTemp[i].ratio * 100).toFixed(2)
        }
      }
      data = dataTemp
      return data
    },
    transformCommBrandHistory (data) {
      if (!data || !data.length) return data
      const dataTemp = data
      for (let i = 0; i < dataTemp.length; i++) {
        dataTemp[i].beautyAmount = this.numberWithCommas(dataTemp[i].amount)
        dataTemp[i].beautyFromAmount = this.numberWithCommas(dataTemp[i].fromAmount)
        dataTemp[i].beautyCreatedAt = this.$moment(dataTemp[i].createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
        dataTemp[i].beautyCreatedAtUtc = this.$moment(dataTemp[i].createdAt * 1000 - 7 * 60 * 60 * 1000).utc().format('YYYY-MM-DD')
        if (dataTemp[i].ratio && dataTemp[i].percent) {
          if (dataTemp[i].ratio === 1) {
            dataTemp[i].ratio = 0.8
          }
          dataTemp[i].percentHistory = (dataTemp[i].percent / dataTemp[i].ratio * 100).toFixed(2)
        }
      }
      data = dataTemp
      return data
    },
    transformCommIronHistory (data) {
      if (!data || !data.length) return data
      const dataTemp = data
      for (let i = 0; i < dataTemp.length; i++) {
        dataTemp[i].beautyAmount = this.numberWithCommas(dataTemp[i].amount)
        dataTemp[i].beautyCreatedAt = this.$moment(dataTemp[i].createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
      }
      data = dataTemp
      return data
    },
    transformTokenReleaseHistory (data) {
      if (!data.data || !data.data.length) return data
      const dataTemp = data.data
      for (let i = 0; i < dataTemp.length; i++) {
        dataTemp[i].beautyPackageAmount = this.numberWithCommas(dataTemp[i].packageAmount)
        dataTemp[i].beautyAmount = this.numberWithCommas(dataTemp[i].amount)
        dataTemp[i].beautyCreatedAt = this.$moment(dataTemp[i].createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
      }
      data.data = dataTemp
      return data
    },
    transformWalletTransactionHistory (data) {
      if (!data || !data.length) return data
      const dataTemp = data
      for (let i = 0; i < dataTemp.length; i++) {
        // dataTemp[i].beautyAmountPps = this.numberWithCommas(dataTemp[i].amountPps)
        // dataTemp[i].beautyAmountUsd = this.numberWithCommas(dataTemp[i].amountUsd)
        // dataTemp[i].beautyBonusIron = this.numberWithCommas(dataTemp[i].bonusIron)
        // dataTemp[i].beautyBonusPps = this.numberWithCommas(dataTemp[i].bonusPps)
        dataTemp[i].beautyTime = this.$moment(dataTemp[i].time).format('YYYY-MM-DD HH:mm:ss')
      }
      data = dataTemp
      return data
    },
    transformStaticalSale (data) {
      if (!data || !data.length) return data
      for (let i = 0; i < data.length; i++) {
        const date = new Date(data[i].timeExpired * 1000).toUTCString()
        data[i].timeExpiredStr = date
        data[i].isExpired = !data[i].timeExpired || (new Date().getTime() >= data[i].timeExpired * 1000)
        data[i].totalSale = new BigNumber(data[i].totalSaleDirect).plus(data[i].totalSaleUndirect).toNumber()
      }
      return data
    },
    transformTransHistory (data) {
      if (!data || !data.length) return data
      const dataTemp = data
      for (let i = 0; i < dataTemp.length; i++) {
        dataTemp[i].beautyPrice = this.numberWithCommas(dataTemp[i].price)
        dataTemp[i].beautyAmountPps = this.numberWithCommas(dataTemp[i].amountPower)
        dataTemp[i].beautyAmountUsd = this.numberWithCommas(dataTemp[i].amountUsd)
        dataTemp[i].beautyBonusIron = this.numberWithCommas(dataTemp[i].tokenBonus)
        dataTemp[i].beautyBonusPps = this.numberWithCommas(dataTemp[i].powerBonus)
        dataTemp[i].beautyCreatedAt = this.$moment(dataTemp[i].createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
      }
      data = dataTemp
      return data
    },
    transformStakingPackages (data) {
      return data
    },
    transformUserStaking (data) {
      for (let i = 0; i < data.length; i++) {
        data[i].beautyAmount = this.numberWithCommas(data[i].amount)
        data[i].beautyAmountBonus = this.numberWithCommas(data[i].amountBonus)
        data[i].beautyCreatedAt = this.$moment(data[i].createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
      }
      return data
    },
    transformUserIeoRef (data) {
      for (let i = 0; i < data.length; i++) {
        data[i].beautyTotalBuy = this.numberWithCommas(data[i].totalBuy)
      }
      return data
    },
    transformUserStakingRef (data) {
      for (let i = 0; i < data.referral.length; i++) {
        const obj = data.referral[i]
        for (let j = 0; j < obj.childrens.length; j++) {
          const child = obj.childrens[j]
          const newTxt = child.address.substring(0, 5) + '...' + child.address.substring(child.address.length - 5, child.address.length)
          const newRefTxt = child.refAddress.substring(0, 5) + '...' + child.refAddress.substring(child.refAddress.length - 5, child.refAddress.length)
          child.beautyAddress = newTxt
          child.beautyRefAddress = newRefTxt
        }
      }
      if (data.topF1Invest.length) {
        data.topF1Invest.forEach((child) => {
          child.beautyAddress = child.address.substring(0, 5) + '...' + child.address.substring(child.address.length - 5, child.address.length)
        })
      }
      return data
    },
    transformUserRefStaking (data) {
      if (!data.data || !data.data.length) return data
      const dataTemp = data.data
      for (let i = 0; i < dataTemp.length; i++) {
        dataTemp[i].beautyAmount = this.numberWithCommas(dataTemp[i].amount)
        dataTemp[i].beautyCreatedAt = this.$moment(dataTemp[i].createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
      }
      return data
    },
    transformComStakingHistory (data) {
      if (!data.data || !data.data.length) return data
      const dataTemp = data.data
      for (let i = 0; i < dataTemp.length; i++) {
        dataTemp[i].beautyAmount = this.numberWithCommas(dataTemp[i].amount)
        dataTemp[i].beautyCreatedAt = this.$moment(dataTemp[i].createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
        dataTemp[i].percentUsd = new BigNumber(dataTemp[i].percentUsd).toFixed(2)
        dataTemp[i].percentToken = new BigNumber(dataTemp[i].percentToken).toFixed(2, BigNumber.ROUND_UP)
      }
      return data
    },
    transformComBinaryStakingHistory (data) {
      if (!data.data || !data.data.length) return data
      const dataTemp = data.data
      for (let i = 0; i < dataTemp.length; i++) {
        dataTemp[i].beautyAmount = this.numberWithCommas(dataTemp[i].amount)
        dataTemp[i].beautyCreatedAt = this.$moment(dataTemp[i].createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
      }
      return data
    },
    transformComDaily (data) {
      if (!data.data || !data.data.length) return data
      const dataTemp = data.data
      for (let i = 0; i < dataTemp.length; i++) {
        dataTemp[i].beautyAmount = this.numberWithCommas(dataTemp[i].amount)
        dataTemp[i].beautyCreatedAt = this.$moment(dataTemp[i].createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
        dataTemp[i].percentUsdStaking = new BigNumber(dataTemp[i].percentUsdStaking).toFixed(2)
        dataTemp[i].percentTokenStaking = new BigNumber(dataTemp[i].percentTokenStaking).toFixed(2, BigNumber.ROUND_UP)
      }
      return data
    },
    transformConvertHistory (data) {
      data.map((item) => {
        item.beautyCreatedAt = this.$moment(item.createdAt * 1000).format('YYYY-MM-DD HH:mm:ss')
        item.amountBeauty = new BigNumber(item.amount).toFixed(2)
        item.amountPpst = new BigNumber(item.percent * item.fromAmount / 100).toFixed(2)
      })
      return data
    },
    // String utils
    beautyCurrency (data) {
      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    numberWithCommas (x) {
      if (x === undefined) return
      var parts = Number(x).toFixed(2).toString().split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      // if (parts[1]) {
      //   parts[1] = Number(parts[1]).toFixed(2)
      // }
      return parts.join('.')
    },
    beautyAmount (x, decimal) {
      x = Number(x)
      const temp = (decimal || decimal === 0) ? x.toFixed(decimal) : x.toFixed(8)
      return this.numberWithCommas(temp)
    },
    beautyAndRoundUpAmount (x, decimal) {
      x = new BigNumber(x)
      const temp = (decimal || decimal === 0) ? x.toFixed(decimal, BigNumber.ROUND_UP) : x.toFixed(8, BigNumber.ROUND_UP)
      return this.numberWithCommas(temp)
    },
    calculateAmount (amount, rate, decimal) {
      if (!amount) return 0
      const temp = new BigNumber(amount).dividedBy(rate)
      const result = new BigNumber(temp).dp(decimal || 2, BigNumber.ROUND_UP).toNumber()
      return result
    },
    calculateMaxSwap (wallet, swapCoin) {
      var result = null
      const numberDecimal = wallet.numberDecimal || Constant.DECIMAL_PLACES
      const division = swapCoin.feeSwap + 1
      const max = new BigNumber(wallet.balanceIeo).dividedBy(division)
      switch (swapCoin.feeType) {
        case Constant.FEE_TYPE.PERCENT:
          result = new BigNumber(max).dp(numberDecimal, BigNumber.ROUND_FLOOR).toNumber()
          break
        case Constant.FEE_TYPE.FIXED:
          result = new BigNumber(wallet.balanceIeo).minus(swapCoin.feeSwap)
          break
        default:
          result = 0
          break
      }
      // Check max balance if charge fee from other wallet
      if (swapCoin.feeSymbol && swapCoin.feeSymbol !== swapCoin.fromSymbol) {
        result = wallet.balanceIeo
      }
      result = this.isLargerOrEqual(result, swapCoin.swapMaxAmount || 0) ? swapCoin.swapMaxAmount : result
      return this.convertExponentialToDecimal(result)
    },
    calculateMaxStakingSwap (wallet, swapCoin) {
      var result = null
      const numberDecimal = wallet.numberDecimal || Constant.DECIMAL_PLACES
      const division = swapCoin.feeSwap + 1
      const max = new BigNumber(wallet.balanceStaking).dividedBy(division)
      switch (swapCoin.feeType) {
        case Constant.FEE_TYPE.PERCENT:
          result = new BigNumber(max).dp(numberDecimal, BigNumber.ROUND_FLOOR).toNumber()
          break
        case Constant.FEE_TYPE.FIXED:
          result = new BigNumber(wallet.balanceStaking).minus(swapCoin.feeSwap)
          break
        default:
          result = 0
          break
      }
      // Check max balance if charge fee from other wallet
      if (swapCoin.feeSymbol && swapCoin.feeSymbol !== swapCoin.fromSymbol) {
        result = wallet.balanceStaking
      }
      result = this.isLargerOrEqual(result, swapCoin.swapMaxAmount || 0) ? swapCoin.swapMaxAmount : result
      return this.convertExponentialToDecimal(result)
    },
    calculateFeeSwap (wallet, swapCoin, amount) {
      if (!amount && swapCoin.feeType === Constant.FEE_TYPE.PERCENT) return 0
      var result = null
      const numberDecimal = wallet.numberDecimal || Constant.DECIMAL_PLACES
      const fee = new BigNumber(amount).multipliedBy(swapCoin.feeSwap)
      switch (swapCoin.feeType) {
        case Constant.FEE_TYPE.PERCENT:
          result = new BigNumber(fee).dp(numberDecimal, BigNumber.ROUND_UP).toNumber()
          break
        case Constant.FEE_TYPE.FIXED:
          result = swapCoin.feeSwap
          break
        default:
          result = 0
          break
      }
      return this.convertExponentialToDecimal(result)
    },
    convertExponentialToDecimal (exponentialNumber) {
      if (!exponentialNumber) return 0
      // sanity check - is it exponential number
      const str = exponentialNumber.toString()
      if (str.indexOf('e') !== -1) {
        const exponent = parseInt(str.split('-')[1], 10)
        const result = exponentialNumber.toFixed(exponent)
        return result
      } else {
        return exponentialNumber
      }
    },
    isLargerOrEqual (firstNumber, secondNumber) {
      const result = new BigNumber(firstNumber).comparedTo(secondNumber)
      if (result === -1) return false
      return true
    },
    isLessOrEqual (firstNumber, secondNumber) {
      const result = new BigNumber(firstNumber).comparedTo(secondNumber)
      if (result === 1) return false
      return true
    },
    checkValidAmountDecimals (value, precision) {
      try {
        const arr = value.toString().split('.')
        if (!arr[1]) return true
        return arr[1].length <= precision || false
      } catch (error) {
        return false
      }
    },
    checkValidDecimals (value, precision) {
      value = Number(value)
      if (Math.floor(value) === value) {
        return true
      }
      try {
        const arr = value.toString().split('.')
        return arr[1].length <= precision || false
      } catch (error) {
        return false
      }
    },
    calculateEstimateAmount (amount, fee, wallet) {
      const numberDecimal = wallet.numberDecimal || Constant.DECIMAL_PLACES
      let result = new BigNumber(amount).minus(fee)
      result = new BigNumber(result).dp(numberDecimal, BigNumber.ROUND_FLOOR).toNumber()
      return result
    },
    calculateEstimateReceiveAmount (amount, rate, numberDecimal) {
      let result = new BigNumber(amount).multipliedBy(rate)
      result = new BigNumber(result).dp(numberDecimal, BigNumber.ROUND_FLOOR).toNumber()
      return result
    },
    calculateFeeTransfer (amount, wallet) {
      if (!amount) return 0
      var result = null
      const numberDecimal = wallet.numberDecimal || Constant.DECIMAL_PLACES
      const fee = new BigNumber(amount).multipliedBy(wallet.transferFee)
      switch (wallet.transferFeeType) {
        case Constant.FEE_TYPE.PERCENT:
          result = new BigNumber(fee).dp(numberDecimal, BigNumber.ROUND_UP).toNumber()
          break
        case Constant.FEE_TYPE.FIXED:
          result = wallet.transferFee
          break
        default:
          result = 0
          break
      }
      return this.convertExponentialToDecimal(result)
    },
    calculateFeeTransferInternal (amount, wallet) {
      if (!amount && wallet.transferInternalFeeType === Constant.FEE_TYPE.PERCENT) return 0
      var result = null
      const numberDecimal = wallet.numberDecimal || Constant.DECIMAL_PLACES
      const fee = new BigNumber(amount).multipliedBy(wallet.transferInternalFee)
      switch (wallet.transferInternalFeeType) {
        case Constant.FEE_TYPE.PERCENT:
          result = new BigNumber(fee).dp(numberDecimal, BigNumber.ROUND_UP).toNumber()
          break
        case Constant.FEE_TYPE.FIXED:
          result = wallet.transferInternalFee
          break
        default:
          result = 0
          break
      }
      return this.convertExponentialToDecimal(result)
    },
    calculateFeeWithdraw (amount, wallet) {
      if (!amount && wallet.withdrawFeeType === Constant.FEE_TYPE.PERCENT) return 0
      var result = null
      const numberDecimal = wallet.numberDecimal || Constant.DECIMAL_PLACES
      const fee = new BigNumber(amount).multipliedBy(wallet.withdrawFee)
      switch (wallet.withdrawFeeType) {
        case Constant.FEE_TYPE.PERCENT:
          result = new BigNumber(fee).dp(numberDecimal, BigNumber.ROUND_UP).toNumber()
          break
        case Constant.FEE_TYPE.FIXED:
          result = wallet.withdrawFee
          break
        default:
          result = 0
          break
      }
      return this.convertExponentialToDecimal(result)
    },
    maxAmountWithoutFee (amount, fee, wallet) {
      const numberDecimal = wallet.numberDecimal
      if (wallet.withdrawFeeSymbol && wallet.withdrawFeeSymbol !== wallet.symbol) {
        fee = 0
      }
      return new BigNumber(amount).minus(fee).dp(numberDecimal, BigNumber.ROUND_DOWN).toNumber()
    },
    maxAmountWithoutInternalFee (amount, fee, wallet) {
      const numberDecimal = wallet.numberDecimal
      if (wallet.transferInternalFeeSymbol && wallet.transferInternalFeeSymbol !== wallet.symbol) {
        fee = 0
      }
      return new BigNumber(amount).minus(fee).dp(numberDecimal, BigNumber.ROUND_DOWN).toNumber()
    },
    estimateWithdrawAmount (amount, fee, wallet) {
      const numberDecimal = wallet.numberDecimal
      if (!amount || !fee) return 0
      if (wallet.withdrawFeeSymbol && wallet.withdrawFeeSymbol !== wallet.symbol) {
        fee = 0
      }
      return new BigNumber(amount).plus(fee).dp(numberDecimal, BigNumber.ROUND_UP).toNumber()
    },
    estimateTransferInternalAmount (amount, fee, wallet) {
      const numberDecimal = wallet.numberDecimal
      if (!amount || !fee) return 0
      if (wallet.transferInternalFeeSymbol && wallet.transferInternalFeeSymbol !== wallet.symbol) {
        fee = 0
      }
      return new BigNumber(amount).plus(fee).dp(numberDecimal, BigNumber.ROUND_UP).toNumber()
    },
    // Check falsy utils
    isValidWalletAddress (address, currentAccount) {
      let isValid = false
      if (!address) return false
      if (currentAccount.currencyCode === 'BCH') {
        const isMainnetAddress = bchaddr.isMainnetAddress
        try {
          isValid = isMainnetAddress(address)
        } catch (e) {
          isValid = false
          console.log(e)
        }
      } else {
        try {
          const formats = this.getCoinFormat(currentAccount.validateAddress)
          isValid = this.isValidAddressWithFormat(formats, address)
        } catch (e) {
          isValid = true
        }
      }
      console.log(isValid, ' address validation')
      return isValid
    },
    getCoinFormat (formatStr) {
      const arr = formatStr.split(';')
      return arr
    },
    isValidAddressWithFormat (arrFormat, address) {
      for (let i = 0; i < arrFormat.length; i++) {
        const format = arrFormat[i]
        const isValid = WAValidator.validate(address, format)
        if (isValid) return true
      }
      return false
    },
    isValidAddress (address, currentAccount) {
      let isValid = false
      if (!address) return false
      try {
        const formats = this.getCoinFormat(currentAccount.validateFormat)
        isValid = this.isValidAddressWithFormat(formats, address)
      } catch (e) {
        isValid = true
      }
      console.log(isValid, ' address validation')
      return isValid
    }
  }
})
